module.exports = __webpack_public_path__ + "static/antd-datepicker-basic-d4c1db84c8b8c461ee74091be0ddf812.gif";